import React from "react";
import { useSelector } from "react-redux";
import ArticleCard from "./ArticleCard";
import PostCard from "./PostCard";
const NewsListOther2 = () => {
  const posts = useSelector((state) =>
    state.posts?.posts
      ?.filter(
        (post) =>
          post.status === "published" &&
          post.slug !== "gioi-thieu" &&
          post.slug !== "dieu-khoan" &&
          post.category?.name === "Kinh tế - Tài chính"
      )
      ?.filter((e) => e.type !== "notification")
      ?.slice(0, 4)
  );

  if (posts.length === 0) {
    return <div className="container mx-auto pt-2"></div>;
  }

  return (
    <div className="container mx-auto pt-2">
      {posts && (
        <div className="lg:col-span-5">
          <ArticleCard key={posts[0]?.id} article={posts[0]} />
        </div>
      )}
      {posts?.slice(1).map((item) => (
        <div key={item.id} className="px-2">
          <PostCard article={item} />
        </div>
      ))}
    </div>
  );
};

export default NewsListOther2;
